import "core-js/modules/es6.array.map.js";
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SubtitleSection from '~/components/atoms/Editorial/SubtitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import Cta from '~/components/atoms/Cta.vue';
var COLORS = {
  grey: 'primary',
  transparent: 'transparent'
};
export default {
  name: 'FieldSection',
  components: {
    TitleSection: TitleSection,
    SubtitleSection: SubtitleSection,
    SimpleParagraph: SimpleParagraph,
    Cta: Cta
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    backgroundColor: function backgroundColor() {
      return this.payload.primary.background_color;
    },
    title: function title() {
      return this.payload.primary.title[0] || {};
    },
    titleColor: function titleColor() {
      return this.payload.primary.title_color;
    },
    subtitle: function subtitle() {
      return this.payload.primary.subtitle[0] || {};
    },
    subtitleColor: function subtitleColor() {
      return this.payload.primary.subtitle_color;
    },
    paragraph: function paragraph() {
      return this.payload.primary.paragraph || [];
    },
    paragraphColor: function paragraphColor() {
      return this.payload.primary.paragraph_color;
    },
    readMore: function readMore() {
      return this.payload.primary.read_more === 'Yes';
    },
    spacing: function spacing() {
      return this.payload.primary.spacing;
    },
    buttons: function buttons() {
      return this.payload.items.map(function (item) {
        return {
          props: {
            url: item.button_url.url || '',
            textBtn: item.button_text || '',
            type: COLORS[item.button_color],
            target: item.button_url.target
          },
          tracking: {
            data: {
              event_category: item.button_event_category || '',
              event_action: item.button_event_action || '',
              event_label: item.button_event_label || ''
            }
          }
        };
      });
    }
  }
};